import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {environment} from 'environment';
import {Question} from 'shared/models/questions/question';
import {QuestionChain} from 'shared/models/questions/question-chain';
import {QuestionChainIds} from 'shared/models/questions/question-chain-ids';
import {Tiplist} from 'shared/models/tips/tiplist';

@Injectable()
export class TreeViewRepository {

  constructor(private http: Http) { }

  public loadTree(treeId: string): Observable<Array<QuestionChain>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.questionChains}/${treeId}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public updateTree(tree: Array<QuestionChainIds>): Observable<Array<QuestionChain>> {
    const headers: Headers = new Headers({'Content-Type': 'application/json'});
    const options: RequestOptions = new RequestOptions({headers: headers, withCredentials: true});
    const body: string = JSON.stringify(tree);

    return this.http.put(`${environment.questionChains}/${tree[0].questions[0]}`, body, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getAllQuestions(): Observable<Array<Question>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(environment.questions, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getAllTipLists(): Observable<Array<Tiplist>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(environment.tiplists, options)
            .map((response: Response) => {
              return response.json();
            });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/dynamic-tips/tree-view/repositories/tree-view.repository.ts